import { call, put, takeEvery } from "redux-saga/effects";
import { marketsRequest } from "../../api/markets";
import { marketsActions } from "../../store/markets/actions";
import { MARKETS_REQUEST } from "../../constants/markets";

function* marketsRequestSaga(): any {
  try {
    const markets = yield call(marketsRequest);
    yield put(marketsActions.marketsSuccessAction(markets));
  } catch (e: any) {
    yield put(marketsActions.marketsFailureAction(e));
  }
}
function* marketsSaga() {
  yield takeEvery(MARKETS_REQUEST, marketsRequestSaga);
}

export default marketsSaga;
